import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import backgroundColor from '@material-ui/core/colors/grey';
import CloseIcon from '@material-ui/icons/Close';

import { getHostingURL } from 'utils';
import { helpDispatch, Tooltip, TooltipTypes } from 'components/admin/Help';
import { getBidTotals } from 'utils';
import { BidsDetail } from '../Bids';
import SendPreview from './SendPreview';

import { startEditBidState2 } from 'store/actions/bids';
import { startEditPreview } from '../../../store/actions/preview';
import { startSendInvoice } from '../../../store/actions/invoicePreview';
import { startSendBid } from '../../../store/actions';
import {
  startEditInvoiceStatuses,
} from '../../../store/actions/invoices';
import {
  startAddStorageInvoice,
  startAddStorageBid
} from '../../../store/actions/files';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  rootContent: {
    backgroundColor: backgroundColor[200],
  },
  content: {
    paddingTop: theme.spacing.unit*12,
    paddingBottom: theme.spacing.unit*4,
    display: 'flex',
    justifyContent: 'center',
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  toolbarLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  toolbarRight: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  toobarCenter: {
    flexGrow: 1,
  },
  center: {
    display: 'flex',
    flexDirection: 'column',
  },
  '@media print': {
    appBar: {
      display: 'none',
    },
  },
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

//TODO: use factory to determine content
const Preview = (props) => {
  const {
    classes,
    preview,
    companyInfo,
    startEditPreview,
    startAddStorageInvoice,
    startSendInvoice,
    startEditInvoiceStatuses,
    startSendBid,
    startAddStorageBid,
    startEditBidState2
  } = props;
  const previewType = preview.data ? preview.data.type : undefined;

  return(
      <Dialog
        fullScreen
        open={preview.show ? preview.show : false}
        transition={Transition}
        className={classes.root}
      >
        <AppBar className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <div className={classes.toolbarLeft}>
              <IconButton
                color="inherit"
                onClick={() => startEditPreview({show: false, data: {}})}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              {preview.data &&
                <Typography variant="title" color="inherit" className={classes.flex}>
                  {preview.data.title}
                </Typography>
              }
            </div>
            <div className={classes.toolbarCenter}>
            </div>
            <div className={classes.toolbarRight}>
              <Tooltip
                type={previewType === "send-invoice" ? TooltipTypes.INVOICE_SEND : undefined}
                placement="bottom"
              >
                <Button color="inherit" onClick={() => {

                  if (preview.data.type === "send-invoice") {
                      const blob = preview.data.blob;
                      const {
                        invoice,
                        client,
                        toEmail,
                        ccEmail = "",
                        note = ""
                      } = preview.data;
                      let lineItems = [];
                      invoice.lineItems.forEach((value, key, map) => lineItems.push({ id: key, ...value }));

                      console.log("INVOICE:", invoice)
                      const data = {
                        "company": {
                          "name": companyInfo.companyName,
                          "phone": companyInfo.phone,
                          "email": companyInfo.email,
                          "address": companyInfo.address,
                        },
                        "client": {
                          "name": client.fullName,
                          "address": {
                            "street": client.address,
                            "city": client.city,
                            "province": client.province,
                            "country": client.country,
                            "postalCode": client.postalCode,
                          }
                        },
                        "invoice": {
                          "invoiceNumber": invoice.invoiceNumber,
                          "invoiceDate": invoice.invoiceDate,
                          "dueDate": invoice.dueDate,
                          "gst": invoice.gst.toFixed(2),
                          "pst": invoice.pst.toFixed(2),
                          "total": invoice.total.toFixed(2),
                          "grandTotal": invoice.grandTotal.toFixed(2),
                          lineItems,
                        },
                      }

                      //TODO: move all this crap model code outside of here
                      const sendData = {
                        "invoice": {
                          "clientName": client.fullName,
                          "companyName": companyInfo.companyName,
                          "invoiceNumber": invoice.invoiceNumber,
                          "grandTotal": invoice.grandTotal.toFixed(2),
                          "balance": invoice.balance.toFixed(2),
                          "note": note,
                        },
                        "options": {
                          "from": {
                            email: companyInfo.email,
                            name: companyInfo.companyName,
                          },
                          "to": {
                            email: toEmail,
                            name: client.fullName,
                          },
                          "subject": companyInfo.companyName,
                          "textPart": "idk forgot what this is for",
                          "attachments": []
                        }
                      }

                      if(ccEmail) {
                        sendData.ccEmail = ccEmail;
                      }

                      let url;
                      const hostingURL = getHostingURL();
                      const generateURL = `${hostingURL}/generateInvoicePDF`;
                      const fetchURL =`${hostingURL}/sendInvoice`;

                      fetch(generateURL, {
                        mode: 'cors',
                        method: 'POST',
                        headers: {
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                          data,
                          token: "LaST18dswfD37VCwVjSsgiselDIDqwwq18iXTvRv"
                        })
                      })
                        .then(response => response.json())
                        .then(base64 => {
                          sendData.options.attachments.push({
                            fileName: "invoice.pdf",
                            base64: base64.pdfDoc,
                          });

                          // options.attachments.push({
                          //   fileName: "invoice.pdf",
                          //   base64: base64.pdfDoc,
                          // });

                          console.log("RESULT:", base64);
                          // decode base64 string, remove space for IE compatibility
                          //NOTE: do this another way, as atob might have compatibility issues???
                          //also, cleaner option: Uint8Array.from(atob(base64_string), c => c.charCodeAt(0))
                          var binary = atob(base64.pdfDoc.replace(/\s/g, ''));
                          var len = binary.length;
                          var buffer = new ArrayBuffer(len);
                          var view = new Uint8Array(buffer);
                          for (var i = 0; i < len; i++) {
                              view[i] = binary.charCodeAt(i);
                          }

                          // create the blob object with content-type "application/pdf"
                          var blob = new Blob( [view], { type: "application/pdf" });
                          console.log("BLOB", blob);

                          url = URL.createObjectURL(blob);
                          // console.log("URL:", url);
                          // window.open(url, '_blank');
                          return url;
                        })
                        .then(() => {
                          return fetch(fetchURL, {
                            mode: 'cors',
                            method: 'POST',
                            headers: {
                              'Accept': 'application/json',
                              'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                              data: sendData,
                              token: "LaST18dswfD37VCwVjSsgiselDIDqwwq18iXTvRv"
                            })
                          });
                        })
                        .then(response => response.json())
                        .then(result => {
                          startEditInvoiceStatuses(invoice.id, { sent: true });
                          startEditPreview({show: false, data: {}});
                          helpDispatch();
                          console.log("SEND EMAIL RESULT:", result)
                        })
                        //.then(() => window.open(url, '_blank'))
                        .catch(error => {
                          console.log("ERROR:", error);
                        });

                  } else if (preview.data.type === "send-bid") {
                    const blob = preview.data.blob;
                    const totals = getBidTotals(preview.data.bidTasks);
                    const {
                      bid,
                      bidTasks,
                      client,
                      toEmail,
                      ccEmail = "",
                      note = ""
                    } = preview.data;

                    const data = {
                      "company": {
                        "name": companyInfo.companyName,
                        "phone": companyInfo.phone,
                        "email": companyInfo.email,
                        "address": companyInfo.address,
                      },
                      "client": {
                        "name": client.fullName,
                        "address": {
                          "street": client.address,
                          "city": client.city,
                          "province": client.province,
                          "country": client.country,
                          "postalCode": client.postalCode,
                        }
                      },
                      "bid": {
                        ...bid,
                        total: totals.total,
                      },
                      "bidTasks": bidTasks.map(task => task),
                    }

                    const sendData = {
                      "bid": {
                        "clientName": client.fullName,
                        "companyName": companyInfo.companyName,
                        "bidNumber": bid.bidNumber,
                        "total": totals.total,
                        "note": note,
                      },
                      "options": {
                        "from": {
                          email: companyInfo.email,
                          name: companyInfo.companyName,
                        },
                        "to": {
                          email: toEmail,
                          name: client.fullName,
                        },
                        "subject": companyInfo.companyName,
                        "textPart": "idk forgot what this is for",
                        "attachments": []
                      }
                    }

                    if(ccEmail) {
                      sendData.ccEmail = ccEmail;
                    }

                    let url;
                    const hostingURL = getHostingURL();
                    const generateURL = `${hostingURL}/generateBidPDF`;
                    const fetchURL =`${hostingURL}/sendBid`;

                    console.log("BIDTASKS:", bidTasks);
                    fetch(generateURL, {
                      mode: 'cors',
                      method: 'POST',
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                        data,
                        token: "LaST18dswfD37VCwVjSsgiselDIDqwwq18iXTvRv"
                      })
                    })
                      .then(response => response.json())
                      .then(base64 => {
                        sendData.options.attachments.push({
                          fileName: "bid.pdf",
                          base64: base64.pdfDoc,
                        });

                        console.log("RESULT:", base64);
                        // decode base64 string, remove space for IE compatibility
                        //NOTE: do this another way, as atob might have compatibility issues???
                        //also, cleaner option: Uint8Array.from(atob(base64_string), c => c.charCodeAt(0))
                        var binary = atob(base64.pdfDoc.replace(/\s/g, ''));
                        var len = binary.length;
                        var buffer = new ArrayBuffer(len);
                        var view = new Uint8Array(buffer);
                        for (var i = 0; i < len; i++) {
                            view[i] = binary.charCodeAt(i);
                        }

                        // create the blob object with content-type "application/pdf"
                        var blob = new Blob( [view], { type: "application/pdf" });
                        console.log("BLOB", blob);

                        url = URL.createObjectURL(blob);
                        // console.log("URL:", url);
                        //window.open(url, '_blank');
                        return url;
                      })
                      .then(() => {
                        return fetch(fetchURL, {
                          mode: 'cors',
                          method: 'POST',
                          headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                          },
                          body: JSON.stringify({
                            data: sendData,
                            token: "LaST18dswfD37VCwVjSsgiselDIDqwwq18iXTvRv"
                          })
                        });
                      })
                      .then(response => response.json())
                      .then(result => {
                        startEditBidState2(bid.id, { sentDate: (new Date()).getTime() });
                        startEditPreview({show: false, data: {}});
                        console.log("SEND BID RESULT:", result);
                      })
                      .catch(error => {
                        console.log("ERROR:", error);
                      });

                    // startAddStorageBid(bid.id, blob)
                    //   .then(() => {
                    //     startSendBid({
                    //       bidId: bid.id,
                    //       bidNumber: bid.bidNumber,
                    //       total: 500,
                    //       recipient: toEmail,
                    //       clientName: client.fullName,
                    //       companyName: companyInfo.companyName,
                    //       oid: companyInfo.oid,
                    //       total: Number(totals.total).toFixed(2),
                    //       companyEmail: companyInfo.email,
                    //       ccEmail,
                    //       note,
                    //     });
                    //     startEditBidState2(bid.id, { sentDate: (new Date()).getTime() });
                    //     startEditPreview({show: false, data: {}});
                    //   })
                  }

                }}>
                  Send
                </Button>
              </Tooltip>
              <Button
                color="inherit"
                onClick={() => startEditPreview({show: false, data: {}})}
              >
                Done
              </Button>
            </div>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{root: classes.rootContent}}>
          <div className={classes.content}>
            <div className={classes.center}>
              <SendPreview />
            </div>
          </div>
        </DialogContent>

      </Dialog>
  );
}

Preview.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const account = state.accountState;
  const companyInfo = {};
  if (account.organizations[0] && account.user) {
    companyInfo.companyName = account.organizations[0].about.name;
    companyInfo.phone = account.organizations[0].about.phone;
    companyInfo.oid = account.organizations[0].id;
    companyInfo.email = account.user.profile.email;
  }

  return ({
    preview: state.previewState,
    companyInfo,
    help: state.help,
  });
}


const mapDispatchToProps = {
  startEditPreview,
  startAddStorageInvoice,
  startSendInvoice,
  startEditInvoiceStatuses,
  startSendBid,
  startAddStorageBid,
  startEditBidState2
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(Preview);



// WEBPACK FOOTER //
// ./src/components/admin/Preview/Preview.jsx